import { render, staticRenderFns } from "./ChargerRecentSessions.vue?vue&type=template&id=328b2124&lang=pug&"
import script from "./ChargerRecentSessions.vue?vue&type=script&lang=ts&"
export * from "./ChargerRecentSessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports